import PropTypes from 'prop-types';
import React from 'react';

class Image extends React.Component {
	render() {
		const image = this.props.image;

		return <img src={'large' in image.sizes ? image.sizes.large.url : image.url} alt="" />;
	}
}

export default Image;

Image.propTypes = {
	image: PropTypes.object,
};
